import { render, staticRenderFns } from "./SfChevron.vue?vue&type=template&id=4287f925&functional=true"
import script from "./SfChevron.vue?vue&type=script&lang=js"
export * from "./SfChevron.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfChevron.vue?vue&type=style&index=0&id=4287f925&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "0be3f4d9"
  
)

export default component.exports